import { Group, Stack, StackProps, Switch, Text } from '@mantine/core';
import { SettingTitle } from './SettingTitle';

type OnOffSettingProps = {
  onChanged: (option: boolean) => void;
  initialOption: boolean;
  title: string;
  description?: string;
};

export function OnOffSetting({
  onChanged,
  initialOption,
  title,
  description,
  ...props
}: OnOffSettingProps & StackProps) {
  return (
    <Stack gap='xs' {...props}>
      <SettingTitle title={title} description={description} />
      <Group gap='xs'>
        <Text>Off</Text>
        <Switch
          checked={initialOption}
          onChange={(e) => onChanged(e.target.checked)}
          color='teal.5'
          size='lg'
          styles={{
            thumb: {
              backgroundColor: 'dark.9',
              borderColor: 'dark.9',
            },
            track: { border: '1px solid dark.9' },
          }}
        />
        <Text>On</Text>
      </Group>
    </Stack>
  );
}
